import { isAlphaEnvironment, isBetaEnvironment, isProdEnvironment } from "../../Util";
import { BASE_URL, STAGE_TYPES } from "../constants";

export const getStage = () => {
  if(isAlphaEnvironment()) {
    return STAGE_TYPES.ALPHA;
  }
  if(isBetaEnvironment()) {
    return STAGE_TYPES.BETA;
  }
  if(isProdEnvironment()) {
    return STAGE_TYPES.PROD;
  }

  return STAGE_TYPES.ALPHA;
}


export const getUrl = (service) => {
  const STAGE = getStage();
  return `${BASE_URL[STAGE]}${service}`;

}
